const adobeEnabled = typeof window.adobe !== 'undefined' && window.adobe.target && window.adobe.target.getOffer;
let offers = [];

const getMboxes = () => {
    return new Promise((resolve) => {
        if (!adobeEnabled) {
            resolve(offers);
        }

        window.adobe.target.getOffer({ // eslint-disable-line import/no-extraneous-dependencies

            mbox: 'target-global-mbox',
            success: function (offer) {
                resolve(offer);
            },
            error: function (status, error) {
                console.log('fail to get adobe error', error);
                resolve(offers);
            },
            timeout: 2000
        });

    });
};

export async function getAdobeTarget() {
    return await getMboxes();
}
